import { SOCIAL_LINKS, STUDIO_NAME } from "../content/site-content.js";
import { trackClickThrough } from "../lib/use-site-tracker.js";

/**
 * Site footer (Req 1.3, 1.4): social media links that open in a new tab and a
 * copyright notice. External links use target="_blank" with
 * rel="noopener noreferrer" so the new tab cannot access the opener.
 *
 * Each external link reports a `footer:<label>` click-through so the Owner can
 * see which destinations visitors leave for; the call cannot throw and never
 * blocks the navigation (Req 2.4, 14.5).
 */
export function Footer(): JSX.Element {
  const year = new Date().getFullYear();
  return (
    <footer className="footer" role="contentinfo">
      <div className="footer__inner">
        <ul className="footer__social">
          {SOCIAL_LINKS.map((link) => (
            <li key={link.label}>
              <a
                className="footer__social-link"
                href={link.href}
                target="_blank"
                rel="noopener noreferrer"
                onClick={() =>
                  trackClickThrough(`footer:${link.label.toLowerCase()}`)
                }
              >
                {link.label}
              </a>
            </li>
          ))}
        </ul>
        <p className="footer__copyright">
          &copy; {year} {STUDIO_NAME}. All rights reserved.
        </p>
      </div>
    </footer>
  );
}
